import { ShieldCheck, MessageCircle, CreditCard } from "lucide-react";
import { TRUST_NOTES, ORDER_FLOW } from "@/constants/content";

/**
 * Order Flow + Trust strip — exact wording from themestudios.in.
 * Premium card layout, real disclaimers (no card details on WhatsApp, etc.).
 */
export default function OrderFlow() {
  const icons = [MessageCircle, ShieldCheck, CreditCard];

  return (
    <section className="px-6 md:px-12 max-w-[1440px] mx-auto mt-32 md:mt-44">
      <p className="text-xs uppercase tracking-[0.22em] text-[#e03c31] font-bold mb-5">
        ✱ How your order works
      </p>
      <h2 className="font-cabinet text-4xl md:text-6xl font-black tracking-tight leading-[0.95] mb-4 max-w-[20ch]">
        Clear package confirmation first,
        then payment, draft, and delivery.
      </h2>
      <p className="text-zinc-400 max-w-2xl mb-12">
        ThemeStudios keeps the ordering flow simple so small businesses know what happens before
        they pay and what happens next after the brief is shared.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-5 gap-3 mb-10">
        {ORDER_FLOW.map((s) => (
          <div
            key={s.n}
            data-testid={`order-step-${s.n}`}
            className="relative bg-[#0a0a0c] border border-white/5 rounded-2xl p-6 hover:border-[#e03c31]/30 transition-colors"
          >
            <span className="font-cabinet text-[#e03c31] text-sm tracking-widest">{s.n}</span>
            <p className="mt-3 text-sm text-zinc-200 leading-snug font-medium">{s.text}</p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {TRUST_NOTES.map((t, i) => {
          const Icon = icons[i] || ShieldCheck;
          return (
            <div
              key={i}
              data-testid={`trust-note-${i + 1}`}
              className="flex items-start gap-3 bg-[#0a0a0c]/60 border border-white/5 rounded-xl p-5"
            >
              <span className="h-9 w-9 rounded-full bg-[#e03c31]/15 text-[#e03c31] flex items-center justify-center shrink-0">
                <Icon size={16} />
              </span>
              <p className="text-sm text-zinc-300 leading-relaxed">{t}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
